import * as React from 'react';
import { Typography } from '@mui/material';
import { TitlePageH1 } from '@tap/mui-ui';

/*
*   Заглушка для карточек действий (ActionCard), для которых еще не реализован функционал. 
*/


export default function EmptyPage({ title }: { title?: string }) {

    return (
        <>
            {title && <TitlePageH1>{title}</TitlePageH1>}
            <Typography>Данный функционал недоступен в пробной версии</Typography>
        </ >
    );
}